<template>
  <el-select
    v-model="port"
    @change="getCty"
    filterable
    clearable
    placeholder="请选择港口"
    size="small"
  >
    <el-option
      v-for="(item,index) in options"
      :key="index"
      :label="item.portChinese+ ' ' +item.portEnglish"
      :value="item.portChinese"
    ></el-option>
  </el-select>
</template>

<script>
import httpApi from "../../http/api";
export default {
  name: "port",
  props: {
    ports: { String },
    single: { Boolean }
  },
  data() {
    return {
      options: [], //国家列表
      port: this.ports,
      singleData: this.single
    };
  },
  methods: {
    getCty(e) {
      this.$emit("getCty", e);
    },
    init() {
      let that = this;
      httpApi
        .listParams( {
          params: {
            type: "sys_port",
            enable:"1"
          }
        })
        .then(res => {
          if (res.data.code == "ok") {
            if(that.singleData){
              let arr = [];
              res.data.data.forEach(v=>{
                arr.unshift(v);
              })
              that.options = arr;
            }else{
              that.options = res.data.data;
            }
          }
        });
    },
  },
  created() {
    this.init();
  },
  watch: {
    ports: function(newVal) {
      this.port = newVal;
    }
  }
};
</script>

<style>
</style>